import React, { useState } from "react";
import NoDataFound from "../NoDataFound/NoDataFound";
import "./AddLogVisiter.css";
import LogVisitorModal from "./Modal/LogVisitorModal";
import ConfirmationModal from "../../../components/Common/ConfirmationModal/ConfirmationModal";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase";

const AddLogVisiter = ({
  visits,
  setVisits,
  isUpdate,
  isBtnDisable,
  dealId,
  addOrUpdateVisits,
  selectedClient,
  Toggler,
  ToggleComponents,
}) => {
  const [singleVisit, setSingleVisit] = useState(null);
  const [modalStatus, setModalStatus] = useState("");
  const [toggleVisits, setToggleVisits] = useState(false);
  const [myIndex, setIndex] = useState(-1);
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const handleOpenDeleteDialog = () => {
    setDeleteDialog(true);
  };
  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      let myIndexTempElement = visits[myIndex];

      visits.splice(myIndex, 1);
      setVisits(visits);
      if (myIndexTempElement.hasOwnProperty("id")) {
        const id = myIndexTempElement.id;
        await deleteDoc(doc(db, "visits", id));
      }
      setDeleteDialog(false);
    }
  };
  return (
    <>
      <LogVisitorModal
        {...{
          modalStatus,
          setModalStatus,
          visits,
          setVisits,
          singleVisit,
          setSingleVisit,
          myIndex,
          addOrUpdateVisits,
          selectedClient,
        }}
      />
      <ConfirmationModal
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this visitor?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
      <div
        className={`log-visitor-card ${
          isBtnDisable === true && "custom-disable-card"
        }`}
      >
        <div className="log-visitor-card-content">
          <div
            className="log-visiter-card-header"
            onClick={() => {
              if (isBtnDisable === false) {
                setIndex(-1);
                setModalStatus("add");
              }
            }}
          >
            <p className="log-visiter-card-title">Add Log Visitors</p>

            <svg
              width={13}
              height={14}
              viewBox="0 0 13 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 12.8324C1 10.5428 3.27773 8.69103 6.082 8.69103C6.64995 8.69103 7.20015 8.76794 7.71486 8.90993M6.082 6.91618C6.86653 6.91618 7.61893 6.60452 8.17368 6.04977C8.72843 5.49502 9.04009 4.74262 9.04009 3.95809C9.04009 3.17356 8.72843 2.42115 8.17368 1.8664C7.61893 1.31165 6.86653 1 6.082 1C5.29746 1 4.54506 1.31165 3.99031 1.8664C3.43556 2.42115 3.12391 3.17356 3.12391 3.95809C3.12391 4.74262 3.43556 5.49502 3.99031 6.04977C4.54506 6.60452 5.29746 6.91618 6.082 6.91618V6.91618Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.5161 10.4503H8.75303M9.63454 9.58658V11.3555M12.001 10.4622C12.001 10.6515 11.9773 10.8349 11.93 11.0124C11.8768 11.249 11.7821 11.4798 11.6579 11.6809C11.4493 12.0314 11.1531 12.3216 10.7983 12.5229C10.4435 12.7241 10.0424 12.8295 9.63454 12.8286C9.05206 12.8304 8.49027 12.6128 8.06084 12.2193C7.88335 12.0655 7.72953 11.8821 7.61121 11.6809C7.386 11.3144 7.2672 10.8924 7.26807 10.4622C7.26768 10.1513 7.32863 9.8434 7.44742 9.55611C7.5662 9.26882 7.7405 9.00778 7.96033 8.78796C8.18015 8.56814 8.44118 8.39384 8.72847 8.27505C9.01576 8.15626 9.32366 8.09532 9.63454 8.0957C10.3327 8.0957 10.9657 8.39743 11.3916 8.88256C11.7703 9.30261 12.001 9.85873 12.001 10.4622Z"
                stroke="white"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className="log-visiter-card-body">
            <div className="title-container">
              <div className="left">
                <span className="transaction-file-title">Log Visitors </span>
                <span className="tot-files">
                  ({visits.length} Log Visitors)
                </span>
              </div>
              <div className="right">
                <div
                  onClick={() => {
                    if (isBtnDisable === false) {
                      // setToggleVisits(!toggleVisits);
                      Toggler();
                    }
                  }}
                  className={`transaction-toggler  ${
                    !ToggleComponents ? "toggle-active" : " "
                  }  `}
                >
                  <svg
                    width="17"
                    height="9"
                    viewBox="0 0 17 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.8"
                      d="M16.2271 8.0975L9.87105 1.5775C9.12041 0.8075 7.89209 0.8075 7.14145 1.5775L0.7854 8.0975"
                      stroke="#545454"
                      strokeWidth="1.5"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
            {ToggleComponents && visits.length > 0 ? (
              <div className="log-visiter-elements-container">
                {visits.map((v, index) => {
                  return (
                    <div
                      className="log-visiter-element"
                      onClick={() => {
                        if (isBtnDisable === false) {
                          setSingleVisit(v);
                          setIndex(index);
                          setModalStatus("update");
                        }
                      }}
                    >
                      <div className="element-type">
                        <p className="visiter-name">{v.client.name}</p>
                        <p
                          className={`${
                            v.status === "interested"
                              ? "interest-label"
                              : "not-interest-label"
                          }`}
                        >
                          {v.status === "interested"
                            ? "Interested"
                            : v.status === "not-interested"
                            ? "Not Interested"
                            : ""}
                        </p>
                      </div>
                      <div className="visiter-comments">
                        <p>{v.comment}. </p>
                      </div>
                      <hr />
                      <div className="date-container">
                        <div className="date-container-date">
                          <span>
                            <svg
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.67673 4.59545V1.81818C8.67673 1.57708 8.57516 1.34585 8.39436 1.17536C8.21356 1.00487 7.96834 0.909091 7.71265 0.909091H5.69772C5.49527 0.381818 4.96502 0 4.33837 0C3.71171 0 3.18147 0.381818 2.97901 0.909091H0.964082C0.433837 0.909091 0 1.31818 0 1.81818V8.18182C0 8.42292 0.101573 8.65415 0.282373 8.82464C0.463173 8.99513 0.708391 9.09091 0.964082 9.09091H3.90935C4.51672 9.65455 5.34583 10 6.26653 10C8.13203 10 9.64082 8.57727 9.64082 6.81818C9.64082 5.95 9.27447 5.16818 8.67673 4.59545ZM4.33837 0.909091C4.60349 0.909091 4.82041 1.11364 4.82041 1.36364C4.82041 1.61364 4.60349 1.81818 4.33837 1.81818C4.07325 1.81818 3.85633 1.61364 3.85633 1.36364C3.85633 1.11364 4.07325 0.909091 4.33837 0.909091ZM0.964082 8.18182V1.81818H1.92816V2.72727H6.74857V1.81818H7.71265V3.94545C7.274 3.75 6.78713 3.63636 6.26653 3.63636H1.92816V4.54545H3.90453C3.61531 4.80455 3.39357 5.11364 3.22003 5.45455H1.92816V6.36364H2.93081C2.90671 6.51364 2.89224 6.66364 2.89224 6.81818C2.89224 7.30909 3.01276 7.76818 3.22003 8.18182H0.964082ZM6.26653 9.09091C4.9361 9.09091 3.85633 8.07273 3.85633 6.81818C3.85633 5.56364 4.9361 4.54545 6.26653 4.54545C7.59696 4.54545 8.67673 5.56364 8.67673 6.81818C8.67673 8.07273 7.59696 9.09091 6.26653 9.09091ZM6.50755 6.93182L7.88619 7.7L7.52466 8.25455L5.78449 7.27273V5H6.50755V6.93182Z"
                                fill="#929292"
                              />
                            </svg>
                          </span>

                          {isUpdate ? (
                            <span>
                              {v.visitTime?.toDate().toDateString() + " "}
                              {v.visitTime?.toDate().getHours()}:
                              {v.visitTime?.toDate().getMinutes()}
                            </span>
                          ) : (
                            <span>
                              {v.visitTime?.toDateString()}{" "}
                              {v.visitTime?.getHours()}:
                              {v.visitTime?.getMinutes()}
                            </span>
                          )}
                        </div>

                        <div
                          className="date-container-delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            setIndex(index);
                            handleOpenDeleteDialog();
                          }}
                        >
                          <svg
                            width={10}
                            height={12}
                            viewBox="0 0 10 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 10.4659C1 8.63424 2.82218 7.15283 5.0656 7.15283C5.51996 7.15283 5.96012 7.21435 6.37189 7.32794M5.0656 5.73294C5.69322 5.73294 6.29515 5.48362 6.73895 5.03982C7.18274 4.59602 7.43207 3.9941 7.43207 3.36647C7.43207 2.73884 7.18274 2.13692 6.73895 1.69312C6.29515 1.24932 5.69322 1 5.0656 1C4.43797 1 3.83605 1.24932 3.39225 1.69312C2.94845 2.13692 2.69913 2.73884 2.69913 3.36647C2.69913 3.9941 2.94845 4.59602 3.39225 5.03982C3.83605 5.48362 4.43797 5.73294 5.0656 5.73294V5.73294Z"
                              stroke="#FF4242"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.745 9.39039H6.255M9 9.40039C9 9.56039 8.98 9.71539 8.94 9.86539C8.895 10.0654 8.815 10.2604 8.71 10.4304C8.53373 10.7266 8.28336 10.9719 7.98352 11.1419C7.68368 11.312 7.34472 11.4011 7 11.4004C6.50773 11.4018 6.03293 11.218 5.67 10.8854C5.52 10.7554 5.39 10.6004 5.29 10.4304C5.09967 10.1206 4.99927 9.76397 5 9.40039C4.99968 9.13765 5.05118 8.87743 5.15157 8.63463C5.25197 8.39183 5.39927 8.17123 5.58506 7.98544C5.77084 7.79966 5.99145 7.65236 6.23425 7.55196C6.47705 7.45157 6.73727 7.40006 7 7.40039C7.59 7.40039 8.125 7.65539 8.485 8.06539C8.805 8.42039 9 8.89039 9 9.40039Z"
                              stroke="#FF4242"
                              strokeWidth="0.7"
                              strokeMiterlimit={10}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ToggleComponents && (
                <div
                  className="add-deal-common-btn"
                  onClick={() => {
                    if (isBtnDisable === false) {
                      setModalStatus(true);
                    }
                  }}
                >
                  <svg
                    width={28}
                    height={27}
                    viewBox="0 0 28 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.6097 13.2033H1M13.8048 1V26.0067"
                      stroke="#767676"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <h3>Add logVisitors</h3>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLogVisiter;
